<template lang="pug">
.container-fluid
  vm-row.login-row(vm-w="12")
    vm-col.login-col(vm-justify="center", vm-align="center", vm-lg=4, vm-sm=12)
      router-view

    vm-col.image-1(vm-align="center", vm-lg=8, vm-offset=4, vm-sm=0, vm-xs=0)
</template>

<script>
export default {
  name: 'BaseAuth'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.image-1 {
  background: linear-gradient(145deg, rgba(255, 111, 0, 0.1), rgba(255, 111, 0, 0.5)), url('../assets/image.jpg') no-repeat center / cover;
  height: 100vh;
  width: 100%;
  position: absolute;
  animation-delay: 18s;
  top: 0;
}
.container-fluid {
  height: 100vh;
  width: 100%;
  overflow: hidden;
  padding-right: 0px !important;
  padding-left: 0px !important;
}
form {
  margin-left: auto;
  margin-right: auto;
  max-width: 380px;
}
.login-background {
  height: 100vh;
}
.login-col {
  -webkit-transition: all .3s;
  transition: all .3s;
  padding: 50px;
  position: fixed;
  z-index: 99;
  background-color: white;
  height: 100%;
  overflow: auto;
}
.login-screen,
.login-row {
  height: 100%;
}
.logo {
  margin-top: 0px;
}
.reset-password {
  padding-top: 0px;
}
.title {
  color: #000000;
  font-size: 17px;
  font-weight: 500;
  line-height: 1.1;
  margin-bottom: 20px;
}
.welcome {
  color: #ffffff;
  max-width: 555px;
  margin-bottom: 65px;
  margin-top: 65px;
  padding-right: 55px;
  h1 {
    font-size: 60px;
  }
  .sub-text {
    color: #ffffff;
  }
}
@media (max-width: 900px) {
  .fadein {
    display: none !important;
  }
}
@media (min-width: 768px) {
  .login-screen {
    form {
      margin-top: 100px !important;
    }
  }
  .welcome {
    margin-bottom: 0px;
    margin-top: 285px;
  }
}
</style>
